"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressFields = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const useFeatureToggle_1 = require("../../../hooks/useFeatureToggle");
const AddressFieldsBasicAlt_1 = require("./address-fields-basic-alt/AddressFieldsBasicAlt");
const AddressFieldsBasic_1 = require("./address-fields-basic/AddressFieldsBasic");
const AddressFieldsBE_1 = require("./address-fields-be/AddressFieldsBE");
const AddressFieldsDE_1 = require("./address-fields-de/AddressFieldsDE");
const AddressFieldsFR_1 = require("./address-fields-fr/AddressFieldsFR");
const AddressFieldsLU_1 = require("./address-fields-lu/AddressFieldsLU");
const AddressFieldsNL_1 = require("./address-fields-nl/AddressFieldsNL");
const AddressFieldsUK_1 = require("./address-fields-uk/AddressFieldsUK");
const AddressFields = (_a) => {
    var { country } = _a, rest = tslib_1.__rest(_a, ["country"]);
    const dataListEnabled = (0, useFeatureToggle_1.useFeatureToggle)('account_datalist_element');
    const props = Object.assign(Object.assign({}, rest), { dataListEnabled });
    switch (country === null || country === void 0 ? void 0 : country.toUpperCase()) {
        case 'BE':
            return (0, jsx_runtime_1.jsx)(AddressFieldsBE_1.AddressFieldsBE, Object.assign({}, props));
        case 'DE':
            return (0, jsx_runtime_1.jsx)(AddressFieldsDE_1.AddressFieldsDE, Object.assign({}, props));
        case 'FR':
            return (0, jsx_runtime_1.jsx)(AddressFieldsFR_1.AddressFieldsFR, Object.assign({}, props));
        case 'LU':
            return (0, jsx_runtime_1.jsx)(AddressFieldsLU_1.AddressFieldsLU, Object.assign({}, props));
        case 'NL':
            return (0, jsx_runtime_1.jsx)(AddressFieldsNL_1.AddressFieldsNL, Object.assign({}, props));
        case 'GB':
        case 'GG':
        case 'JE':
            return (0, jsx_runtime_1.jsx)(AddressFieldsUK_1.AddressFieldsUK, Object.assign({}, props));
        case 'BFPO':
        case 'IE':
        case 'AU':
        case 'NZ':
            return (0, jsx_runtime_1.jsx)(AddressFieldsBasicAlt_1.AddressFieldsBasicAlt, Object.assign({}, props));
        default:
            return (0, jsx_runtime_1.jsx)(AddressFieldsBasic_1.AddressFieldsBasic, Object.assign({}, props));
    }
};
exports.AddressFields = AddressFields;
